import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { stripeService } from '../services/stripe';

const SubscriptionSuccess: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [subscription, setSubscription] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const verifySubscription = async () => {
      if (!sessionId) {
        setError('No session ID provided');
        setLoading(false);
        return;
      }

      try {
        const data = await stripeService.verifySubscription(sessionId);
        setSubscription(data);
      } catch (err) {
        console.error('Error verifying subscription:', err);
        setError('Failed to verify subscription. Please contact support.');
      } finally {
        setLoading(false);
      }
    };

    verifySubscription();
  }, [sessionId]);

  if (loading) {
    return (
      <Container className="py-5">
        <Row>
          <Col className="text-center">
            <Spinner animation="border" variant="primary" />
            <p className="mt-3">Verifying your subscription...</p>
          </Col>
        </Row>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5">
        <Row>
          <Col>
            <Alert variant="danger">
              <h4>Error</h4>
              <p>{error}</p>
              <p>Please contact our support team for assistance.</p>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow-lg">
            <Card.Body className="text-center p-5">
              <FontAwesomeIcon 
                icon={faCheckCircle} 
                size="5x" 
                className="text-success mb-4"
              />
              <h1 className="mb-3">Welcome to DHS Cleaning!</h1>
              <p className="lead mb-4">
                Your subscription has been successfully activated.
              </p>
              {subscription?.name && (
                <div className="mb-4">
                  <h4>Subscription Plan: {subscription.name}</h4>
                </div>
              )}
              <div className="bg-light p-4 rounded mb-4">
                <h5 className="mb-3">What's Next?</h5>
                <ol className="text-start">
                  <li className="mb-2">Check your email for account setup instructions</li>
                  <li className="mb-2">Download our mobile app to get started</li>
                  <li className="mb-2">Add your team members and start scheduling</li>
                  <li className="mb-2">Contact support if you need any help</li>
                </ol>
              </div>
              <button 
                className="btn btn-primary btn-lg rounded-pill px-5"
                onClick={() => navigate('/')}
              >
                Go to Dashboard
              </button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SubscriptionSuccess;